<div class="reporte-container">
  <div class="header">
    <h2>{{ 'PLANS_WITHOUT_BENEFICIARIES' | translate }}</h2>
    <button class="btn-descargar" *ngIf="!loading && planesActivos.length > 0" (click)="descargarExcel()">
      <i class="fas fa-file-excel"></i>{{ 'DOWNLOAD_EXCEL' | translate }}
    </button>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p class="loading-text">{{ 'LOADING_DATA' | translate }}</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && planesActivos.length === 0" class="empty-container">
    <div class="empty-icon">
      <i class="fas fa-inbox"></i>
    </div>
    <h3>{{ 'NO_RESULTS' | translate }}</h3>
    <p>{{ 'NO_PLANS_WITHOUT_BENEFICIARIES' | translate }}</p>
  </div>

  <div *ngIf="!loading && planesActivos.length > 0">
    <div class="resumen">
      <div class="card-resumen">
        <h3>{{ 'TOTAL_PLANS' | translate }}</h3>
        <p class="numero-grande">{{ totalPlanes }}</p>
      </div>
      
      <div class="card-resumen">
        <h3>{{ 'PLANS_BY_TYPE' | translate }}</h3>
        <ul class="lista-planes">
          <li *ngFor="let plan of planesPorTipo | keyvalue">
            <span>{{ plan.key }}</span>
            <span class="badge">{{ plan.value }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tabla-container">
      <div class="overflow-auto" style="max-height: 400px;">
        <table class="tabla-reportes">
          <thead>
            <tr>
              <th>{{ 'FIRST_NAME' | translate }}</th>
              <th>{{ 'LAST_NAME' | translate }}</th>
              <th>{{ 'EMAIL' | translate }}</th>
              <th>{{ 'SALE_ID' | translate }}</th>
              <th>{{ 'PLAN' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of planesActivos">
              <td>{{ plan.firstName }}</td>
              <td>{{ plan.lastName }}</td>
              <td>{{ plan.email }}</td>
              <td>{{ plan.saleId }}</td>
              <td>{{ plan.plan }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>